var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /* eslint-disable react/no-multi-comp */
import { Link } from 'react-router-dom';
import React from 'react';
import { Breadcrumb } from 'flowbite-react';
import { ChevronLeftIcon } from '@heroicons/react/20/solid';
import { Translate } from "../../../I18N";












const SettingsContent = ({ children, className }) => /*#__PURE__*/
_jsx("div", {
  className: `${className || ''} flex flex-col h-full pb-14 lg:pb-0`,
  "data-testid": "settings-content" }, void 0,

children
);


const SettingsHeader = ({ contextId, title, children, path, className }) => /*#__PURE__*/
_jsx("div", { className: `${className || ''} flex pt-5 pb-4 px-5 `, "data-testid": "settings-content-header" }, void 0, /*#__PURE__*/
_jsx(Link, { to: "/settings", className: "block lg:hidden" }, void 0, /*#__PURE__*/
_jsx(ChevronLeftIcon, { className: "w-8 stroke-1 lg:hidden" }), /*#__PURE__*/
_jsx("span", { className: "sr-only" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Navigate back")
)
), /*#__PURE__*/
_jsx(Breadcrumb, { className: "!relative p-1 flex right-0 h-4 !bg-transparent m-0 !w-full flex-wrap align-middle" }, void 0,
Array.from((path === null || path === void 0 ? void 0 : path.entries()) || []).map(([key, value]) => /*#__PURE__*/
_jsx(Breadcrumb.Item, { href: value, className: "max-w-xs" }, key, /*#__PURE__*/
_jsx(Translate, { className: "max-w-xs truncate hover:underline" }, void 0, key)
)
),
title !== undefined && /*#__PURE__*/
_jsx(Breadcrumb.Item, { className: "max-w-xs" }, void 0, /*#__PURE__*/
_jsx(Translate, { context: contextId || 'System', className: "max-w-xs truncate" }, void 0,
title
)
)

),
children
);


SettingsContent.Header = SettingsHeader;
SettingsContent.Body = ({ children, className }) => /*#__PURE__*/
_jsx("div", { className: `${className || ''} flex-grow px-5`, "data-testid": "settings-content-body" }, void 0,
children
);


SettingsContent.Footer = ({ children, className }) => /*#__PURE__*/
_jsx("div", {
  className: `fixed bottom-0 left-0 w-full px-4 py-3 bg-white border-t border-gray-200 lg:sticky z-1 ${
  className || ''
  }`,
  "data-testid": "settings-content-footer" }, void 0,

children
);

export { SettingsContent };